import dayjs, { Dayjs } from "dayjs"
import { IAgreement } from "./agreement.types"
import { Status } from "@/types/Status"
import { safeDayjs } from "@/helpers/dateHelper"
export class Agreement implements IAgreement {
  id: number
  startDate: Dayjs
  endDate: Dayjs | null
  orderedDate?: Dayjs
  isCancelled: boolean
  productCode: string
  productName: string
  juniferNumber: string

  constructor(data: {
    id: number
    startDate: string
    endDate: string
    orderedDate: string | null
    isCancelled: boolean
    productName: string
    productCode: string
    juniferNumber: string
  }) {
    this.id = data.id
    this.startDate = dayjs(data.startDate)
    this.endDate = data.endDate === "9999-12-31" ? null : dayjs(data.endDate)
    this.orderedDate = safeDayjs(data.orderedDate)
    this.isCancelled = data.isCancelled
    this.productName = data.productName
    this.productCode = data.productCode
    this.juniferNumber = data.juniferNumber
  }

  get isActive() {
    return this.endDate === null || this.endDate.isAfter(dayjs())
  }

  get isPending() {
    return this.startDate.isAfter(dayjs())
  }

  get isSmartPayAsYouGo() {
    return this.productCode.includes("PAYG")
  }

  get status(): Status {
    const today = dayjs()
    if (
      this.startDate.isBefore(today) &&
      (this.endDate === null || this.endDate.isAfter(today))
    ) {
      return new Status("normal", "Active")
    } else if (this.startDate.isAfter(today)) {
      return new Status("caution", "Upcoming")
    } else if (this.endDate?.isBefore(today)) {
      return new Status("default", "Completed")
    } else {
      return new Status("caution", "Pending")
    }
  }
}
